'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DataElementStringContainer = undefined;

var _containerConfig = require('./containerConfig');

var _containerConfig2 = _interopRequireDefault(_containerConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataElementStringContainer = exports.DataElementStringContainer = undefined;

exports.DataElementStringContainer = DataElementStringContainer = function DataElementStringContainer(refs) {
    Ext.define('Ext.ux.container.DataElementStringContainer', {
        extend: 'Ext.container.Container',
        alias: 'widget.dataelementstringcontainer',
        cls: 'ns-dxselector',
        layout: 'column',
        bodyStyle: 'border:0 none',
        style: 'margin: ' + _containerConfig2.default.margin,
        getRecord: function getRecord() {
            var record = {};

            record.dimension = this.dataElement.id;
            record.name = this.dataElement.name;

            if (this.valueCmp.getValue()) {
                record.filter = this.operatorCmp.getValue() + ':' + this.valueCmp.getValue();
            }

            return record;
        },
        setRecord: function setRecord(record) {
            this.operatorCmp.setValue(record.operator);
            this.valueCmp.setValue(record.filter);
        },
        initComponent: function initComponent() {
            var container = this;

            this.nameCmp = Ext.create('Ext.form.Label', {
                text: this.dataElement.name,
                flex: 1,
                style: 'padding:' + _containerConfig2.default.namePadding
            });

            this.addCmp = Ext.create('Ext.button.Button', {
                cls: 'ns-linkbutton',
                style: 'padding: 0',
                height: 18,
                text: 'Duplicate',
                handler: function handler() {
                    container.duplicateDataElement();
                }
            });

            this.removeCmp = Ext.create('Ext.button.Button', {
                cls: 'ns-linkbutton',
                style: _containerConfig2.default.removeCmpStyle,
                height: 18,
                text: 'Remove',
                handler: function handler() {
                    container.removeDataElement();
                }
            });

            this.operatorCmp = Ext.create('Ext.form.field.ComboBox', {
                valueField: 'id',
                displayField: 'name',
                queryMode: 'local',
                editable: false,
                width: _containerConfig2.default.operatorCmpWidth,
                style: 'margin-bottom:0',
                value: 'LIKE',
                store: {
                    fields: ['id', 'name'],
                    data: [{ id: 'LIKE', name: 'Contains' }, { id: 'EQ', name: 'Is exact' }]
                }
            });

            this.valueCmp = Ext.create('Ext.form.field.Text', {
                width: _containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth,
                style: 'margin-bottom:0'
            });

            this.items = [{
                xtype: 'container',
                layout: 'hbox',
                width: _containerConfig2.default.nameCmpWidth,
                items: [this.nameCmp,
                //this.addCmp,
                this.removeCmp]
            }, this.operatorCmp, this.valueCmp];

            this.self.superclass.initComponent.call(this);
        }
    });
};
//# sourceMappingURL=DataElementStringContainer.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ux/DataElementStringContainer.js
 ** module id = 184
 ** module chunks = 0 1
 **/